export default "__VITE_ASSET__IkroyRNd__"